$(document).ready(function(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if(urlParams.has("section")) {
    paramChangeVideos(urlParams.get("section"));
  }

  $('#tab-options').change(function(){
    changeVideos($(this).val())
  });
  
  $('.tabs-item').click(tabClick)
  $('.play-btn').click(playVideo)
})

// Tab functions
function tabClick(){
  removeActiveClass()
  addActiveClass($(this))
  changeVideos($(this).data('target'))
}

function addActiveClass(btn){
  btn.addClass('active')
}

function removeActiveClass(){
  $('p.tabs-item.active').removeClass('active')
}

function changeVideos(tabValue){
  $('div.visible').removeClass("visible");
  let sectionId= tabValue;
  $("[data-id='"+sectionId+"']").addClass("visible");
}

function paramChangeVideos(value) {
  if(document.querySelector("[data-id = '" + value + "']")) {
      removeActiveClass();
      document.querySelector("[data-target = '" + value + "']").classList.add("active");
      document.querySelector("#tab-options").value = value;
      changeVideos(value);
    }
}

// Play video functions
function playVideo(){
    let videoId = $(this).data('url')
  	let video = `
		<div id='video-container' class='video__bg' onclick='closeVideo()'>
			<div class='video__container'>
			  <div class='close__video'><i onclick='closeVideo()' class="fa-solid fa-xmark close__btn"></i></div>
              <iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
		</div>
	`;
    jQuery('body').prepend(video)
}
  
function closeVideo(){
  	$("#video-container").remove();
}